import { render, staticRenderFns } from "./DetailCenter.vue?vue&type=template&id=8db4bc0e&"
import script from "./DetailCenter.vue?vue&type=script&lang=js&"
export * from "./DetailCenter.vue?vue&type=script&lang=js&"
import style0 from "./DetailCenter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports